<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-if="stockTakingReport.status !== 'recorded' && stockTakingReport.receipt_file"
      v-can="'stocktakingreport.view'"
      class="item"
      effect="dark"
      content="Bizonylat nyomtatása"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-printer"
        style="margin-left: 5px;"
        @click.stop="openReceipt"
      />
    </el-tooltip>
    <el-tooltip
      v-if="stockTakingReport.status === 'recorded'"
      v-can="'stocktakingreport.update'"
      class="item"
      effect="dark"
      content="Leltár jegyzőkönyv véglegesítés"
      placement="top"
    >
      <el-button
        type="success"
        size="mini"
        :loading="closeButtonLoader"
        icon="el-icon-check"
        @click.stop="close"
      />
    </el-tooltip>
    <el-tooltip
      v-if="stockTakingReport.status === 'recorded'"
      v-can="'stocktakingreport.update'"
      class="item"
      effect="dark"
      content="Előnézet"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-view"
        style="margin-left: 5px;"
        @click.stop="previewReceipt"
        :loading="previewButtonLoader"
      />
    </el-tooltip>
    <el-tooltip
      v-can="'stocktakingreport.update'"
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click.stop="updateStockTakingReport"
      />
    </el-tooltip>
    <el-tooltip
      v-if="stockTakingReport.status !== 'done'"
      v-can="'stocktakingreport.delete'"
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
    >
      <el-popover
        v-model="deleteConfirmVisible"
        placement="bottom"
        trigger="manual"
        width="171"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteStockTakingReport"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
          @click.stop="deleteConfirmVisible = true"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['stockTakingReport'],
    data() {
      return {
        deleteButtonLoader: false,
        closeButtonLoader: false,
        deleteConfirmVisible: false,
        previewButtonLoader: false,
      };
    },

    methods: {
      async deleteStockTakingReport() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('stockTakingReport/delete', this.stockTakingReport.id);
          this.$store.dispatch('stockTakingReport/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      updateStockTakingReport() {
        this.$router.push('/processes/stock-takings/stock-taking-reports/update/' + this.stockTakingReport.id);
      },
      openReceipt() {
        if (this.stockTakingReport.receipt_file && this.stockTakingReport.receipt_file.path) {
          window.open(this.stockTakingReport.receipt_file.path);
        }
      },
      async previewReceipt() {
        this.previewButtonLoader = true;
        const response = await axios.get('api/stock-taking-reports/preview/' + this.stockTakingReport.id, {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/pdf'
          },
        });
        this.previewButtonLoader = false;

        const newBlob = new Blob([response], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
      },
      async close() {
        this.closeButtonLoader = true;
        try {
          await axios.post('api/stock-taking-reports/close/' + this.stockTakingReport.id);
        } catch (e) {
        }
        this.$store.dispatch('stockTakingReport/fetchAll');
        this.closeButtonLoader = false;
      },
    }
  };
</script>

